export enum NotFoundPageSource {
  Offer,
  Task,
}
